import React from "react";
import * as Icons from "lucide-react";
import { services } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Services() {
  const scrollTo = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="max-w-2xl mb-16">
          <span className="font-body text-xs tracking-luxe uppercase text-[#B0603F]">Prestations</span>
          <h2 className="font-serif-display text-5xl md:text-7xl font-light text-[#3A302A] mt-3 leading-[0.95]">
            Mes <span className="font-script text-[#B0603F]">services</span>
          </h2>
          <p className="mt-5 font-body text-[#6B5D53] text-lg leading-relaxed">
            Un accompagnement complet pour donner vie à votre marque, de l'idée à la publication.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Star;
            return (
              <Reveal key={s.key} delay={i * 80}>
                <div className="group relative h-full bg-[#FAF5EF] border border-[#E7D8C6] rounded-3xl p-8 md:p-10 overflow-hidden hover:border-[#B0603F] hover:shadow-[0_28px_60px_-30px_rgba(58,48,42,0.5)] transition-all duration-500 hover:-translate-y-1.5">
                  <div className="absolute -right-8 -top-8 w-32 h-32 rounded-full bg-[#F3E9DD] group-hover:bg-[#B0603F]/10 transition-colors duration-500" />
                  <div className="relative">
                    <div className="flex items-start justify-between">
                      <span className="inline-flex w-14 h-14 rounded-2xl bg-[#F3E9DD] items-center justify-center text-[#B0603F] group-hover:bg-[#B0603F] group-hover:text-[#FAF5EF] transition-colors duration-500">
                        <Icon size={26} />
                      </span>
                      <span className="font-serif-display text-5xl text-[#E7D8C6] group-hover:text-[#B79A80] transition-colors">
                        0{i + 1}
                      </span>
                    </div>
                    <h3 className="font-serif-display text-3xl text-[#3A302A] mt-6 mb-3">{s.title}</h3>
                    <p className="font-body text-[#6B5D53] leading-relaxed">{s.text}</p>
                    <div className="flex flex-wrap gap-2 mt-6">
                      {s.tags.map((t) => (
                        <span key={t} className="font-body text-xs tracking-wide-2 uppercase text-[#8F4A2E] bg-[#F3E9DD] rounded-full px-3 py-1.5">
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="text-center mt-14">
          <button
            onClick={scrollTo}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#3A302A] text-[#FAF5EF] text-sm tracking-wide-2 uppercase hover:bg-[#B0603F] transition-colors duration-300"
          >
            Discutons de votre projet
          </button>
        </Reveal>
      </div>
    </section>
  );
}
